import { useRebookSliceOrigin } from "@b2bportal/core-flights-rebook";
import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import defaultStyles from "./RebookSliceOrigin.module.scss";
import type { RebookSliceOriginProps } from "./types";
import { CoreFlightsRebookComponent } from "~core-flights-rebook/components/rebook-component";
import { useFlightsRebookStyles } from "~core-flights-rebook/styles";

const COMPONENT_KEY = CoreFlightsRebookComponent.RebookSliceOrigin;

export const RebookSliceOrigin = (props: RebookSliceOriginProps) => {
  const styles = useFlightsRebookStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { className, children } = props;
  const { text } = useRebookSliceOrigin(props);

  return (
    <div className={clsx(block, className)}>
      <div className={cn("icon")}>
        <div className={cn("circle")} />
        <div className={cn("line")} />
      </div>
      <div className={cn("label")}>
        <div className={cn("location-name")}>{text.originName}</div>
        <div className={cn("location-code")}>({text.originCode})</div>
      </div>
      {children}
    </div>
  );
};
